


import { Component, Prop, Vue } from "vue-property-decorator";

import { Roles } from "App";
import { Dictionary } from "App/Contracts";
import { Role } from "App/Models";
import { Resource, Right } from "App/UseCases/Roles/Privileges";

/* Renders the privilege matrix (one card per resource, one checkbox per right) and enforces the
   cascade in place: ticking Update/Create ticks Read, unticking Read unticks the broader right.
   A right that a granted broader right depends on is shown locked (Read while Update is on). */
@Component
export default class PrivilegeGrid extends Vue {
    /* The reactive privilege holder. Every boolean key (PlanRead, PlanUpdate, …) must already be a
       own property so Vue tracks it; the editor seeds them to false. */
    @Prop() public Privileges!: Role;

    @Prop( { default: true } )
    Editable!: boolean;

    /* Collapsed by default (like the desktop privilege editor): each resource shows a granted-count
       badge and expands on click. */
    private open: Dictionary<boolean> = {};

    private get resources(): Resource[] {
        return Roles.Privileges.GetResources();
    }

    private isOpen( resource: Resource ): boolean {
        return this.open[ resource.Id ] === true;
    }

    private toggleResource( resource: Resource ): void {
        this.$set( this.open, resource.Id, !this.open[ resource.Id ] );
    }

    private grantedCount( resource: Resource ): number {
        return resource.Rights.filter( right => this.isChecked( right ) ).length;
    }

    private isChecked( right: Right ): boolean {
        return ( this.Privileges as any )[ right.Key ] === true;
    }

    private isLocked( right: Right ): boolean {
        return Roles.Privileges.IsLocked( this.Privileges, right.Key );
    }

    private toggle( right: Right ): void {
        if( !this.Editable || this.isLocked( right ) )
            return;

        Roles.Privileges.ApplyCascade( this.Privileges, right.Key, !this.isChecked( right ) );

        this.$emit( "Change" );
    }
}
